import React from 'react';
import { isChunkLoadError, reloadOnceForChunkError } from '../../utils/lazyWithRetry';

const boxStyle = {
  minHeight: '60vh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 12,
  padding: 24,
  textAlign: 'center',
  fontFamily: 'system-ui, sans-serif',
  color: '#374151',
};

const buttonStyle = {
  padding: '10px 22px',
  border: 'none',
  borderRadius: 8,
  background: '#1d3b85',
  color: '#fff',
  fontSize: 15,
  fontWeight: 600,
  cursor: 'pointer',
};

/** Replaces the blank screen when a page fails to download or crashes; resets on navigation. */
class ChunkErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    if (isChunkLoadError(error)) reloadOnceForChunkError();
  }

  componentDidUpdate(prevProps) {
    if (this.state.error && prevProps.resetKey !== this.props.resetKey) this.setState({ error: null });
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    const chunk = isChunkLoadError(error);
    return (
      <div role="alert" style={boxStyle}>
        <h2 style={{ margin: 0, fontSize: 20, color: '#111827' }}>
          {chunk ? "This page didn't load" : 'Something went wrong on this page'}
        </h2>
        <p style={{ margin: 0, maxWidth: 420, lineHeight: 1.5 }}>
          {chunk
            ? 'The connection was interrupted while loading TracktCRM. Your data is safe — please reload.'
            : 'Your data is safe. Reloading the page usually fixes this.'}
        </p>
        <button type="button" style={buttonStyle} onClick={() => window.location.reload()}>
          Reload page
        </button>
      </div>
    );
  }
}

export default ChunkErrorBoundary;
